import { useMutation, useQueryClient } from '@tanstack/react-query';
import { DocsRequests } from 'src/requests/docs';
import { QueryKey } from 'src/utils/react-query';

import { Doc } from 'src/@types/docs';
import { UNTITLED } from '../utils';

export const useDocMutation = () => {
  const queryClient = useQueryClient();

  const { mutateAsync: createDoc, isLoading: isCreatingDoc } = useMutation(
    (data: { parent?: string; body?: string; title?: string } = {}) =>
      DocsRequests.createDoc(data.title || UNTITLED, data.parent, data.body),
    {
      onSuccess(newContent) {
        queryClient.setQueriesData<Doc[]>([QueryKey.DOCS], (contents) => [
          ...(contents || []),
          newContent,
        ]);
        return newContent;
      },
    },
  );

  const { mutateAsync: deleteDoc, isLoading: isDeletingDoc } = useMutation(
    DocsRequests.deleteDoc,
    {
      onSuccess(deletedDoc) {
        queryClient.setQueryData<Doc[]>([QueryKey.DOCS], (contents) =>
          contents?.filter((content) => content._id !== deletedDoc._id),
        );
      },
    },
  );

  const { mutateAsync: leaveDoc, isLoading: isLeavingDoc } = useMutation(
    DocsRequests.leaveDoc,
    {
      onSuccess(deletedDoc) {
        queryClient.setQueryData<Doc[]>([QueryKey.DOCS], (contents) =>
          contents?.filter((content) => content._id !== deletedDoc._id),
        );
      },
    },
  );

  return {
    createDoc,
    isCreatingDoc,
    deleteDoc,
    isDeletingDoc,
    leaveDoc,
    isLeavingDoc,
  };
};
